import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import ButtonSelectFormFieldBase from '../../normal/ButtonSelectFormField';

const propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  id: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    textLabel: PropTypes.string,
    textValue: PropTypes.string,
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  initialValue: PropTypes.string.isRequired,
};

export const ViewableButtonSelectFormField = props => {
  const {
    id,
    classes,
    isEditing,
    initialValue,
    label,
    options,
    input: { value, onChange },
  } = props;

  const renderField = () => {
    if (isEditing) {
      return (
        <ButtonSelectFormFieldBase
          id={id}
          label={label}
          value={value}
          options={options}
          onChange={onChange}
        />
      );
    }

    return (
      <>
        <div className={classes.textLabel}>{label}</div>
        <div className={classes.textValue}>{initialValue || 'N/A'}</div>
      </>
    );
  };

  return <div>{renderField()}</div>;
};

ViewableButtonSelectFormField.propTypes = propTypes;

export default withStyles(styles)(ViewableButtonSelectFormField);
